/**
 * Pile des dialogues ouverts (Modal, Drawer, confirmation).
 *
 * Chaque dialogue écoutait Échap sur `document` pour son propre compte : une
 * confirmation ouverte au-dessus d'un tiroir fermait, d'un seul Échap, la
 * confirmation ET le tiroir — avec la saisie en cours. Seul le dialogue du
 * dessus doit réagir ; les autres attendent leur tour.
 */
const stack: string[] = [];

export function pushDialog(id: string): void {
  stack.push(id);
}

export function popDialog(id: string): void {
  const index = stack.lastIndexOf(id);
  if (index >= 0) stack.splice(index, 1);
}

export function isTopDialog(id: string): boolean {
  return stack[stack.length - 1] === id;
}
